import { fromJS } from "immutable";

const GameUtils = {
  getGames(context, link) {
    if (link) {
      let params = { size: 10 };

      context.setState({ isLoading: true });

      context.props
        .fetchGames(link, params)
        .then((resp) => {
          context.setState({
            games: fromJS(resp),
            isLoading: false,
          });
        })
        .catch(() => {
          context.setState({ isLoading: false });
        });
    } else {
      context.setState({ isLoading: false });
    }
  },
};

export default GameUtils;
